import { SafeArea } from '@capacitor-community/safe-area'
// Docs: https://github.com/capacitor-community/safe-area

const safeArea = () => {
  SafeArea.enable({
    config: {
      customColorsForSystemBars: true,
      statusBarColor: '#00000000', // transparent
      statusBarContent: 'light',
      navigationBarColor: '#00000000', // transparent
      navigationBarContent: 'light'
    }
  })
}

export default safeArea
